"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureRequired = exports.assertTotal = exports.allEnumValues = exports.assertType = void 0;
const assert_1 = __importDefault(require("assert"));
/**
 * Assert that an object has a general type (i.e., Record<string, number>) but return the const type of it (i.e., {test: 123})
 */
const assertType = () => (specific) => specific;
exports.assertType = assertType;
/**
 * Problem: for enums with string values, it is not possible to get all values programmatically (without mixing them up with the keys)
 * This function ensures that all enum values have been passed and returns an array with all those values.
 * While solutions are possible that require each enum member to only be specified once (i.e., https://stackoverflow.com/a/55858763),
 * they are significantly more difficult to understand and heavier on the compiler.
 */
const allEnumValues = (enumValues) => Object.keys(enumValues);
exports.allEnumValues = allEnumValues;
const assertTotal = (pointsPerLevel, total) => {
    const sum = Object.values(pointsPerLevel).reduce((acc, curr) => acc + curr, 0);
    (0, assert_1.default)(sum === total, `expected the total to be ${total}`);
};
exports.assertTotal = assertTotal;
function ensureRequired(obj, properties) {
    /**
     * Due to the way TypeScript types work, we cannot bridge between types and
     * their runtime representation.
     * Therefore it is crucial to only ever return exactly the same keys as defined
     * in the properties array.
     */
    const missing = properties.filter((prop) => !(prop in obj) || obj[prop] === undefined);
    if (missing.length > 0) {
        throw new Error(`Missing required properties: ${missing.join(", ")}`);
    }
    return properties.reduce((acc, prop) => {
        if (obj[prop] === undefined) {
            throw new Error(`Property ${String(prop)} is undefined`);
        }
        acc[prop] = obj[prop];
        return acc;
    }, {});
}
exports.ensureRequired = ensureRequired;
